import axios from "./Interceptor.js"
let address = window.global_config.BASE_URL2;

let dataCenterApi = {
  getFieldPageList: (data) => {
    return axios({
      method: "post",
      url: `${address}DataMapping/GetPageList`,
      data
    })
  },
  PatientAttributeList: () => {
    return axios({
      method: "get",
      url: `${address}PatientCenter/GetPatientAttributeList`,
    })
  },
  addField: (data) => {
    return axios({
      method: "post",
      url: `${address}DataMapping/Add`,
      data
    })
  },
  editField: (data) => {
    return axios({
      method: "post",
      url: `${address}DataMapping/Edit`,
      data
    })
  },
  removeField: (data) => {
    return axios({
      method: "post",
      url: `${address}DataMapping/Delete`,
      data
    })
  },
  reportPageList: (data) => {
    return axios({
      method: "post",
      url: `${address}DataMappingLog/GetPageList`,
      data
    })
  },
}

export default dataCenterApi;